import {
  Bar
} from 'vue-chartjs'
import {
  Agent
} from 'http'
import moment from "moment";

export default {
  extends: Bar,
  props: ['sums', 'unbezahlt', 'verrOffen'],
  data() {
    return {
      chartdata: {
        datasets: [
          {
            label: 'Verrechnet nicht bezahlt netto',
            type: "scatter",
            backgroundColor: '#b9dff8',
            data: this.verrOffen,
            barThickness: 3,
            minBarLength: 20,
            borderWidth: 0,
          },
          {
            label: 'Verrechnet netto',
            type: "scatter",
            backgroundColor: '#36a2eb',
            data: this.sums,
            barThickness: 3,
            minBarLength: 20,
            borderWidth: 0,
          },
          {
            label: 'Offen netto',
            type: "scatter",
            backgroundColor: '#ff6384',
            data: this.unbezahlt,
            barThickness: 3,
            minBarLength: 20,
            borderWidth: 0,
          },
          
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: true,
        tooltips: {
          backgroundColor: '#2c3e50',
          callbacks: {
            title: function(tooltipItem, data) {
              return moment(tooltipItem[0].xLabel, 'MMM D, YYYY, HH:mm:ss a').format('DD.MM.YYYY')
            },
            label: function(tooltipItem, data) {
              const dataset = data.datasets[tooltipItem.datasetIndex];
              const item = dataset.data[tooltipItem.index];
              const value = parseFloat(item.y).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
            
              let status;
              if (tooltipItem.datasetIndex === 0) {
                status = "Nicht bezahlt: ";
              } else if (tooltipItem.datasetIndex === 1) {
                status = "Verrechnet: ";
              } else {
                status = "Offen: ";
              }
            
              return [item.a, status + value];
            }
            
          }
        },
        legend: {
          labels: {
            fontFamily: "Avenir",
          }
        },
        scales: {
          xAxes: [{
            offset: true,
            type: 'time',
            time: {
              unit: 'month',
              displayFormats: {
                month: 'MMM'
              }
            },
            ticks: {
              fontFamily: "Avenir",
            }
          }],
          yAxes: [{
            ticks: {
              beginAtZero: true,
              fontFamily: "Avenir",
            }
          }]
        }
      }
    }
  },
  mounted() {
    this.renderChart(this.chartdata, this.options)
  }
}